export default __webpack_public_path__ + "static/media/image.92dc1068.png";